<template lang="html">
    <div class="filter">
        <header>
            <label>{{ filter.label }}</label>
            <a @click="removeFilter(filter)">
                Remove
            </a>
        </header>

        <div class="input-group">
            <ds-multiselect
                v-if="modifiers.length > 1"
                ref="modifiers"
                v-model="filter.modifier"
                name="modifiers"
                class="modifiers"
                bind-value-only
                :options="modifiers"
            />

            <div class="modifier-value">
                <component
                    :is="filterComponent"
                    v-if="filterComponent"
                    v-model="filter"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    DATE_MODIFERS,
    TAGS_MODIFERS,
    TEXT_MODIFERS,
    CURRENCY_MODIFERS,
    CONTACT_TYPE_MODIFERS,
    SELECT_MODIFERS,
} from './analytics.constants';

import AnalyticsDateFilter from './AnalyticsDateFilter';
import AnalyticsTagsFilter from './AnalyticsTagsFilter';
import AnalyticsTextFilter from './AnalyticsTextFilter';
import AnalyticsCurrencyFilter from './AnalyticsCurrencyFilter';
import AnalyticsContactTypeFilter from './AnalyticsContactTypeFilter';
import AnalyticsSelectFilter from './AnalyticsSelectFilter';

export default {
    props: {
        value: Object,
    },

    data() {
        return {
            filter: this.value,
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },
    },

    computed: {
        modifiers() {
            switch (this.filter.type) {
            case 'date':
                return DATE_MODIFERS;
            case 'tags':
                return TAGS_MODIFERS;
            case 'contacttype':
                return CONTACT_TYPE_MODIFERS;
            case 'text':
                return TEXT_MODIFERS;
            case 'currency':
                return CURRENCY_MODIFERS;
            case 'select':
                return SELECT_MODIFERS;
            default:
                return TEXT_MODIFERS;
            }
        },

        filterComponent() {
            switch (this.filter.type) {
            case 'date':
                return AnalyticsDateFilter;
            case 'tags':
                return AnalyticsTagsFilter;
            case 'contacttype':
                return AnalyticsContactTypeFilter;
            case 'text':
                return AnalyticsTextFilter;
            case 'currency':
                return AnalyticsCurrencyFilter;
            case 'select':
                return AnalyticsSelectFilter;
            default:
                return AnalyticsTextFilter;
            }
        },
    },

    methods: {
        removeFilter() {
            this.$emit('remove');
        },
    },
};
</script>

<style lang="scss" scoped>
.filter {
    background-color: $color-gray-lighter;
    padding: $spacing-200 $spacing-200 0 $spacing-200;
    border-radius: $border-radius;
    margin-bottom: $spacing-400;

    @media($small) {
        padding: $spacing-200;
    }
}

.modifier-value {
    flex: 2;
    max-width: calc(100%  - 15.625rem);
}

header {
    margin-bottom: $spacing-200;
    display: flex;
    align-items: center;
    justify-content: space-between;

    label {
        font-weight: $font-weight-regular;
        font-size: 16px;
    }

    a {
        font-weight: $font-weight-semibold;
        font-size: $font-size-sm;
    }
}

@media($small) {
    .input-group {
        display: flex;
        flex-direction: column;
    }

    .modifier-value {
        max-width: 100%;
        width: 100%;
    }
}
</style>
